import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/signup-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/app/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/lib/configs/store-config.ts");
;
import(/* webpackMode: "eager" */ "/app/node_modules/jotai/esm/react.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter-family\",\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-geist-family\"}],\"variableName\":\"geist\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ActiveExchangeSync"] */ "/app/provider/active-exchange-sync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsSync"] */ "/app/provider/analytics-sync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntercomProvider"] */ "/app/provider/intercom-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileKeyboardSync"] */ "/app/provider/mobile-keyboard-sync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/provider/query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SoundSettingsSync"] */ "/app/provider/sound-settings-sync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/provider/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetSaveGuard"] */ "/app/provider/widget-save-guard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebSocketProvider"] */ "/app/service/ws/websocket-context.tsx");
